export const CONTENT_TYPE = {
  //---技术支持---
  11: 'APP下载',
  12: 'API文档',
  13: '常见问题',
  14: '使用教程',
  //---关于我们---
  21: '关于FBS',
  22: '白皮书',
  23: '官方公告',
  24: '上币申请',
  //---条款说明---
  31: '用户条款',
  32: '服务协议',
  33: '费率说明',
  34: '法律声明',
  35: 'C2C操作说明',
  //投票规则
  41: '投票规则',
  42: '预测规则',
  //公司
  51: '公司简介',
  52: '官宣视频',
  53: '社区节点广告',
  54: '武侠介绍',
  55: '武侠帮规',
  56: '云算力规则'
};
